import { supabase } from '@/lib/supabase-client'
import { logger } from '@/logger'

import { SubscriptionStatus, subscriptionStatusSchema } from '../types'

export async function fetchSubscriptionStatus(): Promise<SubscriptionStatus> {
  const { data, error } = await supabase.rpc('get_subscription_status')

  if (error) {
    logger.error('Failed to fetch subscription status', { error })
    throw error
  }

  const parsed = subscriptionStatusSchema.safeParse(data)

  if (!parsed.success) {
    logger.error('Subscription status schema validation failed', { issues: parsed.error.issues })
    throw new Error('Invalid subscription status payload')
  }

  return {
    profile: parsed.data.profile,
    status: parsed.data.status,
    blocked: parsed.data.blocked,
    reason: parsed.data.reason as SubscriptionStatus['reason'],
    trialEnd: parsed.data.trial_end,
  }
}
